export enum NotificationSeenFrom {
  browser = 'browser',
}
